export default [
    {
        path: '/comissoes',
        view: 'comissoes/Index',
        name: 'Comissões',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Comissões',
                disabled: true,
                exact: true,
                to: '/comissoes',
            },
        ],
    },
    {
        path: '/comissoes/nova',
        view: 'comissoes/New',
        name: 'Cadastrar Comissão',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Comissões',
                disabled: false,
                exact: true,
                to: '/comissoes',
            },
            {
                text: 'Nova',
                disabled: true,
                exact: true,
                to: '/comissoes/nova',
            }
        ],
    },
    {
        path: '/comissoes/editar/:id',
        view: 'comissoes/Edit',
        name: 'Edição de Comissão',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Comissões',
                disabled: false,
                exact: true,
                to: '/comissoes',
            },
            {
                text: 'Edição',
                disabled: true,
                exact: true,
                to: '/comissoes/editar/:id',
            }
        ],
    },
    {
        path: '/comissoes/visualizar/:id',
        view: 'comissoes/View',
        name: 'Visualização de Comissão',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Comissões',
                disabled: false,
                exact: true,
                to: '/comissoes',
            },
            {
                text: 'Visualização',
                disabled: true,
                exact: true,
                to: '/comissoes/visualizar/:id',
            }
        ],
    },
    {
        path: '/comissoes/excluir',
        permissions: ['ADMINISTRADOR', 'GESTOR']
    },
];
